// Auth configuration
// Admin users have access to: Mark as Paid, Owner Distribution Settings

// Parse admin emails from environment variable (comma-separated)
const adminEmailsEnv = (import.meta.env.VITE_ADMIN_EMAILS || 'ken@xyzstrategy.co').replace(/\\n/g, '').trim();
export const ADMIN_EMAILS = adminEmailsEnv.split(',').map((email: string) => email.trim().toLowerCase());

// Domains that are ALWAYS permitted to log in, regardless of environment config.
// Every @xyzstrategy.co and @holladay.xyz address must be able to sign in, so a stale
// or single-domain VITE_ALLOWED_DOMAIN value can never lock these out.
const CORE_ALLOWED_DOMAINS = ['@xyzstrategy.co', '@pedventures.com', '@holladay.xyz'];

// Optional extra domains from the environment (comma-separated). These are ADDED to the
// core set — env config can widen the allowlist but can never remove a core domain.
// VITE_ALLOWED_DOMAIN (singular) is still read for backwards compatibility.
const extraDomainsEnv = (
  import.meta.env.VITE_ALLOWED_DOMAINS ||
  import.meta.env.VITE_ALLOWED_DOMAIN ||
  ''
).replace(/\\n/g, '').trim();

const extraDomains = extraDomainsEnv
  .split(',')
  .map((d: string) => d.trim().toLowerCase())
  .filter(Boolean);

export const ALLOWED_DOMAINS: string[] = Array.from(
  new Set([...CORE_ALLOWED_DOMAINS, ...extraDomains]),
);

// Keep the singular for backwards compatibility
export const ALLOWED_DOMAIN = ALLOWED_DOMAINS[0] ?? '@xyzstrategy.co';

// Check if email is an admin
export const isAdmin = (email: string | undefined): boolean => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
};

// Check if email is allowed to login (any of the allowed domains, or explicitly listed admins)
export const isAllowedEmail = (email: string): boolean => {
  const lowerEmail = email.trim().toLowerCase();
  if (ADMIN_EMAILS.includes(lowerEmail)) return true;
  return ALLOWED_DOMAINS.some((domain) => lowerEmail.endsWith(domain));
};
